// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hvCt","colBig":"styles_colBig__1x7kZ","colSmall":"styles_colSmall__2y3oe","shopifyNameWrapper":"styles_shopifyNameWrapper__3Y0e6"};